import { Injectable } from '@angular/core';
import { OrdersQueryParams } from '@app/utils/interfaces/order.interface';
import { BehaviorSubject, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderFilterService {
  private readonly activeFiltersSubject = new BehaviorSubject<OrdersQueryParams>({});

  public readonly activeFilters$ = this.activeFiltersSubject.asObservable();
  public readonly hasActiveFilters$ = this.activeFilters$.pipe(
    map((filters) =>
      Boolean(
        filters.creators?.length ||
        filters.orderStatuses?.length ||
        filters.deliveryTypes?.length ||
        filters.dateCreated ||
        filters.startDate ||
        filters.endDate,
      ),
    ),
  );

  get activeFilters(): OrdersQueryParams {
    return this.activeFiltersSubject.value;
  }

  public setFilters(filters: OrdersQueryParams): void {
    this.activeFiltersSubject.next(filters);
  }

  public updateFilters(filters: Partial<OrdersQueryParams>): void {
    this.activeFiltersSubject.next({
      ...this.activeFilters,
      ...filters,
    });
  }

  public removeFilter(key: keyof OrdersQueryParams): void {
    const updated = { ...this.activeFilters };

    delete updated[key];

    this.activeFiltersSubject.next(updated);
  }

  public clearFilters(): void {
    this.activeFiltersSubject.next({});
  }
}
